import "assets/scss/components/conversation/list.scss";
import React, { useState, useEffect, useRef } from "react";
import { useApp } from "context";
import { Conversation } from "components";
import { Chat } from "types";

type Props = {
  items: Array<Chat>;
  selectedIndex: number;
  onSelect: (item: Chat) => void;
};

export const List = (props: Props) => {
  const { theme } = useApp();

  const [selectedIndex, setSelectedIndex] = useState<number>(-1);
  const initialRender = useRef<boolean>(true);

  useEffect(() => {
    if (initialRender.current) {
      setSelectedIndex(props.selectedIndex);
      initialRender.current = false;
    } else {
      handleClick(props.items[props.selectedIndex], props.selectedIndex);
    }
  }, [props.selectedIndex]);

  const handleClick = (item: Chat, index: number) => {
    setSelectedIndex(index);
    props.onSelect && props.onSelect(item);
  };

  return (
    <div
      className="qh-conversation-list"
      style={{ backgroundColor: theme.palette.background.accent }}
    >
      <div className="qh-content">
        {props.items.map((item: Chat, i: number) => {
          return (
            <Conversation.Item
              key={i}
              index={i}
              item={item}
              onClick={handleClick}
              selected={selectedIndex === i}
              isLast={i === props.items.length - 1}
            />
          );
        })}
      </div>
    </div>
  );
};
